module.exports = __webpack_public_path__ + "img/home.c3ebe45d.png";